import { useState, useEffect } from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';
import { colors } from 'theme/colors/colors';
import { CheckListItemProps } from 'types/gamification';

export const CheckListItem = ({
  title,
  progressLabel,
  isDone,
  hasHoverEffect,
}: CheckListItemProps) => {
  const successColor = useColorModeValue(
    'success.lightMode.default',
    'success.darkMode.default'
  );
  const inactiveColor = useColorModeValue(
    'state.lightMode.inactive',
    'state.darkMode.inactive'
  );
  const inProgressColor = useColorModeValue(
    'primary.lightMode.400',
    'primary.darkMode.400'
  );
  const circleColorHover = colors.taplioDashboard.blue;
  const circleColor = colors.taplioPublic.border;

  const [progressColor, setProgressColor] = useState(inactiveColor);

  useEffect(() => {
    if (isDone) {
      setProgressColor(successColor);
    } else if (progressLabel) {
      setProgressColor(inProgressColor);
    } else {
      setProgressColor(inactiveColor);
    }
  }, [isDone, progressLabel, successColor, inProgressColor, inactiveColor]);

  return (
    <Flex
      alignItems='center'
      justifyContent='space-between'
      w='100%'
      color={isDone ? successColor : ''}
      role='group'
    >
      <Flex alignItems='center' justifyContent='start' gap='20px'>
        <Box
          display='flex'
          width='20px'
          height='20px'
          padding='2px'
          gap='10px'
          borderRadius={100}
          border='2px solid'
          borderColor={isDone ? successColor : circleColor}
          _groupHover={
            hasHoverEffect
              ? {
                  borderColor: isDone ? successColor : circleColorHover,
                }
              : {}
          }
          bg={isDone ? successColor : 'transparent'}
          alignItems='center'
          justifyContent='center'
        >
          {isDone && <FaCheck color='white' />}
        </Box>
        <Text
          fontWeight='500'
          textDecorationLine={isDone ? 'line-through' : ''}
          fontSize='sm'
        >
          {title}
        </Text>
      </Flex>
      <Text
        pl={2}
        color={progressColor}
        overflow='hidden'
        textOverflow='ellipsis'
        whiteSpace='nowrap'
        fontWeight='500'
        fontSize='xs'
      >
        {isDone && 'Done'}
        {!isDone && (progressLabel || 'Not yet')}
      </Text>
    </Flex>
  );
};
